/* unplugin-vue-components disabled */import script from "./header-scroll.vue?vue&type=script&setup=true&lang=js"
export * from "./header-scroll.vue?vue&type=script&setup=true&lang=js"

import "./header-scroll.vue?vue&type=style&index=0&id=05de5a81&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05de5a81"]])

export default __exports__